export default class RegExpRules {
  public static Phone = /^\+[0-9]*$/;
  public static ReferralSlug = /^[\wа-яА-Я\d\-]+$/;
}
